module.exports = __webpack_public_path__ + "static/media/livestock-section.31045d73.png";